const OauthService = {
  createShopifyConnection: async (params) => {
    const { data } = await ovpFetch('/settings/shopping/shopify/oauth', {
      method: 'POST',
      body: JSON.stringify(params),
      defaultContentType: true,
    });
    return data;
  },
  getShopifyConsentURL: async (shop) => {
    const { data } = await ovpFetch('/settings/shopping/shopify/oauth/consent', {
      method: 'POST',
      body: JSON.stringify(
        {
          shop,
        },
      ),
      defaultContentType: true,
    });
    return data;
  },
  createShoplineConnection: async (payload) => {
    const { data } = await ovpFetch('/settings/shopping/shopline/oauth', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return data;
  },
};

// eslint-disable-next-line
export { OauthService };
